/**
 * @title TradeIn Router
 * @description Router page with access to different tradein areas
 */
import * as React from "react";
import {FC} from "react";
import {Route, Routes} from "react-router-dom";
import {TradeInPage} from "./TradeInPage";
import {TermsPage} from "./TermsPage";

export const TradeInRouter: FC<any> = () => {
   return <Routes>
      <Route path={"/"} element={<TradeInPage/>}/>
      <Route path={"pdf"} element={<TradeInPage/>}/>
      <Route path={"qrpdf"} element={<TradeInPage/>}/>
      <Route path={"shops"} element={<TradeInPage/>}/>
      <Route path={"terms"} element={<TermsPage/>}/>
      <Route path={":tradeInId/terms"} element={<TermsPage/>}/>
   </Routes>

}